exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-inputs{width:100%;text-align:left;margin:0 1.5rem;font-size:.8rem}.user-inputs textarea{width:100%;min-height:4rem;font-size:.8rem}.input-error{color:red;margin-left:.5rem}.poly-title{display:flex;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-703cf121","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInputs.vue
// module id = 43
// module chunks = 0